'use client';
import { useState } from 'react';

import { CompanyProps } from './company';

import { Checkbox } from '@components/Form';
import { toastError, toastSuccess } from '@components/root/NotificationProxy';
import { useUserStore } from '@utils/user';

const company = ['wcw1', 'wcw2', 'wcw3', 'wcw4', 'wcw5', 'wcw6'];
const position = ['wpw1', 'wpw2', 'wpw3', 'wpw4', 'wpw5', 'wpw6'];

export default function Interests({ labels, user }: CompanyProps) {
  const [isLoading, setLoading] = useState<boolean>(false);
  const userStore = useUserStore();

  const renderAnswers = (values: any[]) =>
    values.map((item) => (
      <Checkbox
        key={item}
        defaultChecked={user?.[item]}
        value={user?.[item]}
        disabled={isLoading}
        wrapperClassName="items-center !text-base"
        onChange={async () => {
          setLoading(true);
          try {
            await fetch(
              `${process.env.NEXT_PUBLIC_API_PUBLIC}/users/profile/edit`,
              {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${userStore.accessToken}`,
                },
                body: JSON.stringify({
                  [item]: !user?.[item],
                }),
              },
            );
            toastSuccess(labels.toast.success);
          } catch (e) {
            toastError(labels.toast.error);
          } finally {
            setLoading(false);
          }
        }}
        label={labels.answers[item]}
      />
    ));

  return (
    <form className="mb-5">
      <div className="mb-1 mt-2.5 text-lg">{labels.companyQuestion}</div>
      <div className="grid lg:grid-cols-2 xl:grid-cols-3">
        {renderAnswers(company)}
      </div>
      <div className="mb-1 mt-2.5 text-lg">{labels.positionQuestion}</div>
      <div className="grid lg:grid-cols-2 xl:grid-cols-3">
        {renderAnswers(position)}
      </div>
    </form>
  );
}
